import http from 'hub-http/clients/apiClient';
export const deleteRecording = engagementId => {
  return http.delete(`post-call/v1/voice-recording/crm/${engagementId}`);
};